<motn-drawer-height-from-bottom
  [addToBottomHeight]="100"
  (clickedOutside$)="clickedOutside$.emit($event)"
>
  @if (!deviceId) {
    <h3>
      Add Device Manually
    </h3>
  }

  @if (deviceId) {
    <h3>
      Configure Device
      <motn-pill squareLetter="d">{{ deviceId }}</motn-pill>
    </h3>
  }

  @if (!device) {
    <motn-spinner></motn-spinner>
  }

  @if (device) {
    <div class="content">
      <div class="flex">
        <div>
          @if (!getHubText()) {
            <div
              class="fake-select"
              [class.error]="!hubMenuOpen"
              (click)="openHubMenu()"
            >
              &nbsp;
            </div>
          }
          @if (getHubText()) {
            <div
              class="fake-select"
              [innerText]="getHubText()"
              (click)="openHubMenu()"
            ></div>
          }
          @if (hubMenuOpen) {
            <motn-popover-select-hubs
              [hubs]="hubs"
              [preselectedHub]="changedFormValues.Hub ?? device?.Hub"
              (clickedOption$)="onSelectHub($event)"
              (clickedOutsideMenu$)="hubMenuOpen = false;"
            ></motn-popover-select-hubs>
          }
          <div class="label">
            <i class="fas fa-square-h"></i>
            Motion Hub
          </div>
        </div>

        <div>
          <input
            [(ngModel)]="initialFormValues.Name"
            (ngModelChange)="updateStatus('edited'); changedFormValues.Name = $event"
          >
          <div
            class="label"
          >
            Device Name
          </div>
        </div>

        @if (getProtocol() !== 'lorawan') {
          <div>
            <input
              [(ngModel)]="initialFormValues.IpAddress"
              (ngModelChange)="updateStatus('edited'); changedFormValues.IpAddress = $event"
            >
            <div
              class="label"
            >
              IP Address
            </div>
          </div>
        }

        @if (!deviceId) {
          <div>
            <select
              [(ngModel)]="initialFormValues.Protocol"
              (ngModelChange)="updateStatus('edited'); changedFormValues.Protocol = $event"
            >
              @for (option of protocolOptions; track option.id) {
                <option
                  [ngValue]="option.id"
                  [innerText]="option.name"
                ></option>
              }
            </select>
            <div
              class="label"
            >
              Protocol
            </div>
          </div>
        }

        @if (getProtocol()) {
          <div>
            <input
              [(ngModel)]="initialFormValues.Address"
              (ngModelChange)="updateStatus('edited'); changedFormValues.Address = $event"
            >
            <div
              class="label"
            >
              {{ getAddressLabel() }}
            </div>
          </div>
        }

        @if (getProtocol() === 'bacnet') {
          <div>
            <input
              [(ngModel)]="initialFormValues.BacnetNetworkNumber"
              (ngModelChange)="updateStatus('edited'); changedFormValues.BacnetNetworkNumber = $event"
            >
            <div
              class="label"
            >
              BACnet Network Number (optional)
            </div>
          </div>

          <div>
            <input
              [(ngModel)]="initialFormValues.BacnetMacAddress"
              (ngModelChange)="updateStatus('edited'); changedFormValues.BacnetMacAddress = $event"
            >
            <div
              class="label"
            >
              BACnet MAC Address (optional)
            </div>
          </div>
        }

        <div>
          <select
            [(ngModel)]="initialFormValues.AutoClear"
            (ngModelChange)="updateStatus('edited'); changedFormValues.AutoClear = $event"
          >
            @for (option of autoClearOptions; track option.id) {
              <option
                [ngValue]="option.id"
                [innerText]="option.name"
              ></option>
            }
          </select>
          <div
            class="label"
          >
            <i class="far fa-bell"></i>
            Auto-Clear Alarms
          </div>
        </div>

        <div>
          <input
            class="monospace"
            [(ngModel)]="initialFormValues.AdvancedConfig"
            (ngModelChange)="updateStatus('edited'); changedFormValues.AdvancedConfig = $event"
          >
          <div
            class="label"
          >
            <i class="fa-solid fa-diamond-exclamation yellow"></i> Advanced Settings
          </div>
        </div>
      </div>

      <motn-save-revert-buttons
        #saveRevertButtonsComponent
        [status]="status"
        [enableRevert]="true"
        (clickedSave$)="save()"
        (updatedStatus$)="updateStatus($event)"
        (clickedRevert$)="revert()"
      ></motn-save-revert-buttons>
    </div>
  }
</motn-drawer-height-from-bottom>